import './Venues.css'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { useGetVenuesQuery, useRemoveVenueMutation } from '../../redux/venuesService/venuesApiSlice'
import { Header } from '../../components/Header/Header.js'
import { ReactComponent as MinusDelete } from '../../icon/minus-delete.svg'
import AddButton from '../../components/AddButton/AddButton.js'
import { BottomMenu } from '../../components/BottomMenu/BottomMenu'

const Venue = () => {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const [removeVenue] = useRemoveVenueMutation()
	const communityUid = localStorage.getItem('communityUid')
	const { data: venues = [], isLoading } = useGetVenuesQuery(communityUid)

	const handleVenue = (item) => {
		sessionStorage.setItem('updatedVenue', JSON.stringify(item))
		navigate('/account/venues/form')
	}

	const handleAddVenue = () => {
		sessionStorage.removeItem('updatedVenue')
	}

	const handleRemoveVenue = (item) => {
		try {
			const response = removeVenue({ venue_uid: item?.uid }).unwrap()

			if(response?.error){
				return
			}
		}
		catch (e) {
			console.log('removeVenue catch error', e)
		}
	}

	if (isLoading) return <h1>Loading...</h1>

	return (
		<>
			<Header
				className="header-container"
				backButton={true}
				backButtonPatch={'/account'}
				subtitle={t('Venues')}
			/>

			<AddButton onClick={handleAddVenue} to={'/account/venues/form'} />

			<div className="venues__wrapper">
				<div className="venues__container">
					{
						venues.length < 1 &&
							<div className="venues__novenues-container">
								<p className="novenues-text">
									{t('There are not venues yet. Add venue')}
								</p>
							</div>
					}

					{
						venues.map((v, index) =>
							<div key={index} className="venues">
								<div onClick={() => handleVenue(v)} className="venues__block">
									<div className="venues-item__number-container">
										<p className="venues-item__number">
											{ index + 1 }
										</p>
									</div>

									<p className="venues-item__name">
										{ v?.name }
									</p>
								</div>

								<div className="venues__delete-button">
									<MinusDelete
										onClick={() => handleRemoveVenue(v)}
										className="venues__delete-button__icon"
									/>
								</div>
							</div>
						)
					}
				</div>
			</div>

			<BottomMenu />
		</>
	)
}

export default Venue
